import { initLayout } from '../layout.js';

initLayout();
